import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { ContratoRateio } from 'src/app/admihair/api/dto/contrato-rateio';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { ContratoRateioService } from 'src/app/admihair/service/contrato-rateio.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-contrato-editar',
  templateUrl: './contrato-editar.component.html',
  styleUrls: ['./contrato-editar.component.scss']
})
export class ContratoEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  id?: number;
  empresaSelecionada?: Empresa;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  contrato?: Contrato;
  subgrupos: Subgrupo[] = [];
  listaGrupos: Grupo[] = [];
  grupoSelecionado: Grupo = {};
  listaRateios: ContratoRateio[] = [];
  modoEdicao: boolean = true;
  progressoRequisicao: boolean = false;
  exibirSpinner: boolean = false;
  

  constructor(private activatedRouter: ActivatedRoute, 
    private contratoService: ContratoService,
    private contratoRateioService: ContratoRateioService,
    private subgrupoService: SubgrupoService,
    private grupoService: GrupoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private confirmationService: ConfirmationService) { }

  @ViewChild('f') form?: any;

  ngOnInit(): void {
    this.exibirSpinner = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CONTRATO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdContrato();
    if (this.permissaoEditar) {
      this.carregarDadosContrato();
    }
    
  }

  carregarIdContrato(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  carregarDadosContrato() {
    forkJoin([
      this.grupoService.listarGruposPorEmpresaECodigoPlanoConta(this.empresaSelecionada?.id, 4),
      this.contratoService.buscarContratoPorId(this.id)
    ]).subscribe({
      next: ([gruposRespose, contratoResponse]: [Grupo[], Contrato]) => {
        this.listaGrupos = gruposRespose;
        this.contrato = contratoResponse;
        this.carregarRateios()
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarRateios(){
    this.contratoRateioService.listarPorContrato(this.contrato?.id).subscribe({
      next: (data: ContratoRateio[]) => {
        this.listaRateios = data;
        this.exibirSpinner = false;
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.contratoService.atualizar(this.id, this.contrato).subscribe({
      next: () => {
        this.atualizarRateios();
        this.exibirMensagemSucesso();
        this.modoEdicao = false;
        this.progressoRequisicao = false;
        
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
        this.progressoRequisicao = false;
      }
    })
    
  }

  atualizarRateios(){
    for(let rateio of this.listaRateios){
      rateio.contrato = this.contrato;
        this.contratoRateioService.salvar(rateio).subscribe({
          next: (data: ContratoRateio) => {
            this.carregarRateios();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
    }
  }

  excluirRateio(rateio: ContratoRateio){
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          if(rateio.id){
            this.contratoRateioService.excluirPorId(rateio.id).subscribe({
              next: () => {
                this.carregarRateios();
              },
              error: (err: any) => {
                this.exibirMensagemErro(err);
              }
            });
          } else {
              const posicao = this.listaRateios.indexOf(rateio);
              this.listaRateios.splice(posicao, 1);

          }
        }
      });
  }

  adicionarRateio(){
    this.subgrupoService.listarSubgruposPorGrupoId(this.grupoSelecionado.id).subscribe({
      next: (data: Subgrupo[]) => {
        let rateios = data.map((item) => ({
          subgrupo: item,
          percentualRateio: item.rateioBasico
        }));
        for(let rateio of rateios){
          if(!this.listaRateios.some(c => c.subgrupo?.id === rateio.subgrupo.id)) {
            this.listaRateios.push(rateio);
          }
        }
        
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
